export const SHOW_SNACKBAR_SUCCESS = "@snackbar/show-snackbar-success";
export const HIDE_SNACKBAR_SUCCESS = "@snackbar/hide-snackbar-success";

export function showSnackbarSuccess(message, severity = "error") {
  return {
    type: SHOW_SNACKBAR_SUCCESS,
    payload: { message, severity },
  };
}

export function hideSnackbarSuccess() {
  return {
    type: HIDE_SNACKBAR_SUCCESS,
  };
}